import { Percent } from '@beamswap/sdk';
import { ONE_BIPS } from '../../constants';

export const formattedPriceImpact = (priceImpact?: Percent) =>
  priceImpact
    ? priceImpact.lessThan(ONE_BIPS)
      ? '<0.01%'
      : `${priceImpact.toFixed(2)}%`
    : '-';
